import React from 'react';
import { connect } from 'react-redux';
import { Navigate } from 'react-router';
import { getAvatar,getApplicationImage } from '../../../action/avatar/getAvatar';
import {getUserBlockStatus} from '../../../action/auth/login'
import { PropTypes } from 'prop-types';
import {getSessionIdFromStorage, getUserContext} from '../../../utils/helpers/storageUtils';


export class Welcome extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            redirect:false,
            profilePicture:props.profilePicture,
            customPath:'/home',
            applicationImage: 'images/home-active-contract-bg.png'

          }
    }

    componentDidMount() {
        this.initializeComponent();
    }

    initializeComponent = async() => {
		const userRole = localStorage.getItem("userRole");
        const actor = sessionStorage.getItem("actor");
		if (userRole === "admin" && !actor) {
			this.setState({
				customPath: "/admin-dashboard"
			});

			setTimeout(() => {
				this.setState({ redirect: true });
			}, 1000);

			return;
		}
		sessionStorage.setItem('blockedUsers', '');
		if (localStorage.getItem('fromWhere') != 'skip') {
			await this.initialLoad();
		} else {
			const applicationImage = await getApplicationImage();
			if (applicationImage?.status === 201 && Array.isArray(applicationImage.data.image) && applicationImage.data.image.length !== 0) {
				let appImg = applicationImage.data.image[1];
				sessionStorage.setItem('applicationImage', appImg);
				this.setState({ applicationImage: appImg });
			} else {
				this.setState({ applicationImage: 'images/home-active-contract-bg.png' });
			}
		}
		await this.setBlockedUserInLocalStorage();
            this.setState({customPath:'/home'})
		setTimeout(() => {
			this.setState({ redirect: true });
		}, 300);
	}

    setBlockedUserInLocalStorage = async() => {
        if(localStorage.getItem('fromWhere')!='skip'){
            let sessionId = getSessionIdFromStorage();
            if(sessionId) {
                const getBlockedUser=await getUserBlockStatus();
                if (getBlockedUser && Array.isArray(getBlockedUser.data.data) && getBlockedUser.data.data.length !== 0) {
                    sessionStorage.setItem('blockedUsers', getBlockedUser.data.data.blockstatus);
                }
            }
        }
    }

    setUserImageInProps = (imageResult) => {
        if(imageResult?.data.statusCode===200){
            sessionStorage.setItem('UserName',imageResult.data.data.first_name+' '+imageResult.data.data.last_name);
            sessionStorage.setItem('mobileNumber', imageResult.data.data.mobile_number);
             if(imageResult.data.data.image_path!==undefined){
                let userPic ='data:image/jpeg;base64,'+imageResult.data.data.image_path
                this.props.setProfilePic(userPic);
            }
             else{
                let userPic= sessionStorage.getItem("profilePicture");
               if(userPic!=null){
                this.props.setProfilePic(userPic);
                }
                if(localStorage.getItem('fromWhere')==='skip'){
                    let defaultImage ='images/profile-avatar.png';
    
                    this.props.setProfilePic(defaultImage);
                }
             }
    
            }
    }

    initialLoad=async()=>{
       const imageResult = await getAvatar(getUserContext());
       const applicationImage = await getApplicationImage();
       this.setUserImageInProps(imageResult);
        if (applicationImage?.status === 201) {
            if (Array.isArray(applicationImage.data.image) && applicationImage.data.image.length !== 0) {
                let appImg = applicationImage.data.image[1];
                this.setState({applicationImage:appImg});
            } else {
                this.setState({applicationImage:'images/home-active-contract-bg.png'});
            }

        } else {
            this.setState({applicationImage:'images/home-active-contract-bg.png'});
        }
     
       
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.profilePicture !== nextProps.profilePicture) {
          return {
            profilePicture: nextProps.profilePicture
          };
        }
        
        return null;
    }
   
    render() { 
        if (this.state.redirect) {
            return <Navigate  to={{pathname: this.state.customPath,state:{applicationImage:this.state.applicationImage}}}/>;
        }
        return ( 
            <div className="layout-fixed">
            <div className="wrapper welcome-page">
                <div className="logo">
                    <img src="images/logo.svg" className="img-fluid" alt="welcome logo"/>
                </div>
                <div className="welcome-content">
                    <p>Awesome, welcome to humm <br></br>and happy shopping!</p>
                </div>
            </div>
          </div> 
         );
    }
}



export const mapStateToProps = (state) => {
    return {
        profilePicture:state.dataStore.profilePicture
    };
   };


 export const mapDispatchToProps = (dispatch) => {
    return {
        setProfilePic:(userPic)=>{
            return dispatch({
                type: 'SET_PROFILE_PIC',
                value: userPic
            });
        }
        
    }
   }

Welcome.propTypes = {
    setProfilePic: PropTypes.func,
    profilePicture: PropTypes.string,
}

export default connect(mapStateToProps,mapDispatchToProps)(Welcome)